import Box from '@material-ui/core/Box';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Autocomplete from '@mui/material/Autocomplete';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import { ReactComponent as ArrowdownSVG } from "assets/icons/arrow-down.svg";
import React from 'react';
import { Item } from './Theme';
import "./index.scss";

export const MenuSingleCheckBox = ({ Items, withBorder,onLedgerAccountChange,onSubLedgerAccountChange,activeLedger,activeSubLedger,disabled }) => {
    const useStyles = makeStyles({
        inputAdornment: {
            '& .MuiSvgIcon-root': {
                cursor: 'pointer',
            },
        },
    });
    const classes = useStyles();

    const handleOptionToggle = ({type, ledger,subLedger}) => () => {
        if(type === 'ledger') {
           onLedgerAccountChange(ledger)
           return;
        }
        if(type === "subLedger") {
          onLedgerAccountChange(ledger)
          onSubLedgerAccountChange(subLedger)
          return;
        }
    };

    const renderOption = (props, option) => {
            return (
                <li {...props} className='li_hover'>
                    <div>
                        <Item key={option?.ledger_name} value={option}  
                        onClick={handleOptionToggle({
                            type: "ledger",
                            ledger: option
                        })}
                        >
                            <FormControlLabel
                                label={
                                    <Typography sx={{ fontSize: 18 }}>
                                        {option?.ledger_name}
                                    </Typography>
                                }
                                control={
                                    <Checkbox
                                        checked={option?._id === activeLedger?.id}
                                    />
                                }
                            />
                        </Item>

                        {option?.sub_ledgers?.length > 0 &&
                            <div>{
                                option?.sub_ledgers?.map((childOption) => (
                                    <Box key={childOption?.id} sx={{ display: 'flex', flexDirection: 'column', ml: 5, color: '#4f4f4f', fontWight: 'normal' }}
                                        onClick={handleOptionToggle({
                                          type: "subLedger",
                                          ledger: option,
                                          subLedger: childOption
                                        })}
                                       >
                                        <FormControlLabel
                                            label={<Typography sx={{ fontSize: 18 }}>
                                                {childOption?.sub_ledger_name}
                                            </Typography>}
                                            control={<Checkbox
                                                checked={childOption?._id === activeSubLedger?.id}
                                            />

                                            }
                                        />

                                    </Box>

                                ))
                            }
                            </div>}


                    </div>
                </li>
            );
    };
    return (
        <div>
            <Autocomplete
                multiple
                id="checkboxes-tags-demo"
                className={classes.root}
                disableCloseOnSelect
                noOptionsText="No related ledgers or subLedgers is available"
                options={Items}
                getOptionLabel={(option) => [option?.ledger_name, ...(option?.sub_ledgers?.map(s => s?.sub_ledger_name) || [])].filter(Boolean).join(" ")}
                filterOptions={(options, { inputValue }) => {
                    const q = inputValue.toLowerCase();
                    return options.filter(o =>
                        o?.ledger_name?.toLowerCase().includes(q) ||
                        o?.sub_ledgers?.some(s => s?.sub_ledger_name?.toLowerCase().includes(q))
                    );
                }}
                sx={{
                    background: "#fff",
                    maxHeight: '52px !important',

                    width: '312px',
                    borderRadius: '5px',

                    '&.MuiFormControl-fullWidth': {
                        borderRadius: '5px',
                        height: '52px',
                        
                    },
                    '&:hover': {
                        border: !withBorder && '1px solid #cccccc'
                    },
                    '&& fieldset': {
                        width: '312px',
                        maxHeight: '52px !important',
                        justifyContent: 'center',
                        border: !withBorder && "0",
                    },

                    '&.Mui-focused ': {
                        maxHeight: '52px !important',
                        border: !withBorder && "1px solid #03b2cb",
                        boxShadow: !withBorder && '0 0 0 3px rgba(52,152,255,.25)',
                        '&& fieldset': {
                            maxHeight: '52px !important',
                            border: !withBorder && "0",
                        },
                    },
                }}
                disableClearable
                renderOption={renderOption}
                renderInput={(params) => (
                    <TextField {...params}
                        placeholder={`Selected Options: ${activeLedger?.name}${activeSubLedger?.name ? ` ${activeSubLedger.name}` : ''}`}
                        sx={{
                            input: {
                                color: 'black',
                                "&::placeholder": {
                                    opacity: 1,
                                },
                            },
                        }}
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                < ArrowdownSVG fill={'#B5B5C3'} style={{
                                    width: '15px',
                                    cursor: 'pointer',
                                    marginRight: '-12px',
                                    marginTop: '-3px',
                                    pointerEvents: 'none',

                                }} />

                            ),
                            classes: {
                                endAdornment: classes.inputAdornment, // Apply custom styles
                            },
                        }}
                    />
                )}
                renderTags={(value, getTagProps) =>
                    <span>
                    </span>
                }
                disabled={disabled}
            >
            </Autocomplete>
        </div >

    );
};